<template>
  <header class="header">
    <div class="container">
      <div class="header__row">
        <router-link to="/" class="logo-link" @click.native="handleClick">
          <img
            src="@/assets/images/logo.svg"
            class="logo"
            :class="{ 'logo_hidden_mob': isContactsPage }"
          >
          <img
            v-if="isContactsPage"
            src="@/assets/images/full-logo.svg"
            class="full-logo"
          >
        </router-link>

        <nav class="nav nav_hidden_mob">
          <!--<router-link to="/mission" class="nav-item">Наши ценности</router-link>
          <router-link to="/services" class="nav-item">Что мы делаем</router-link>
          <router-link to="/about" class="nav-item">О нас</router-link>
          <router-link to="/contacts" class="nav-item">Контакты</router-link>-->
          <div class="nav-item">Наши ценности</div>
          <div class="nav-item">Что мы делаем</div>
          <div class="nav-item">О нас</div>
          <router-link to="/" class="nav-item">Контакты</router-link>
        </nav>

        <div
          class="nav-burger"
          :class="{ 'nav-burger_active': isVisibleMobMenu }"
          @click="isVisibleMobMenu = !isVisibleMobMenu"
        >
          <div class="nav-burger__item"></div>
          <div class="nav-burger__item"></div>
          <div class="nav-burger__item"></div>
        </div>
      </div>
    </div>

    <div
      class="mobile-menu"
      :class="{ 'mobile-menu_active': isVisibleMobMenu }"
    >
      <div class="container">
        <div class="mobile-menu-nav">
          <!--<router-link to="/mission" class="mobile-menu-nav__item" @click.native="handleClick">
            <h3 class="mobile-menu-nav__title">Наши ценности</h3>
          </router-link>
          <router-link to="/services" class="mobile-menu-nav__item" @click.native="handleClick">
            <h3 class="mobile-menu-nav__title">Что мы делаем</h3>
          </router-link>
          <router-link to="/about" class="mobile-menu-nav__item" @click.native="handleClick">
            <h3 class="mobile-menu-nav__title">О нас</h3>
          </router-link>
          <router-link to="/contacts" class="mobile-menu-nav__item" @click.native="handleClick">
            <h3 class="mobile-menu-nav__title">Контакты</h3>
          </router-link>-->
          <div class="mobile-menu-nav__item">
            <h3 class="mobile-menu-nav__title">Наши ценности</h3>
          </div>
          <div class="mobile-menu-nav__item">
            <h3 class="mobile-menu-nav__title">Что мы делаем</h3>
          </div>
          <div class="mobile-menu-nav__item">
            <h3 class="mobile-menu-nav__title">О нас</h3>
          </div>
          <router-link to="/" class="mobile-menu-nav__item" @click.native="handleClick">
            <h3 class="mobile-menu-nav__title">Контакты</h3>
          </router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { TweenMax } from 'gsap'

export default {
  name: 'Header',
  data () {
    return {
      isVisibleMobMenu: false
    }
  },
  computed: {
    isContactsPage () {
      return this.$route.name === 'contacts'
    }
  },
  mounted () {
    TweenMax.from('.nav-item:nth-child(1)', 0.3, { y: '-10px', opacity: 0 })
    TweenMax.from('.nav-item:nth-child(2)', 0.3, { y: '-10px', opacity: 0, delay: 0.15 })
    TweenMax.from('.nav-item:nth-child(3)', 0.3, { y: '-10px', opacity: 0, delay: 0.3 })
    TweenMax.from('.nav-item:nth-child(4)', 0.3, { y: '-10px', opacity: 0, delay: 0.45 })
  },
  methods: {
    handleClick () {
      this.isVisibleMobMenu = false
    }
  }
}
</script>
